import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import {
  Wrapper,
  InfoLink,
  Anchor,
  FeedbackBtn,
  FeedbackBtnContainer,
} from './elements';
import { useText, useConfig } from 'common/hooks';
import { ICON } from 'resources/constants';

const deps = {
  language: state.appContainer.language.locale,
  beginTutorial: sequences`challenge.tutorial.beginTutorial`,
};

export function ChaSec02({
  language,
  beginTutorial,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const config = useConfig();

  const faqLinks = {
    en: 'https://www.ducky.eco/en/support/ducky-challenge/faq',
    es: 'https://www.ducky.eco/es/support/ducky-challenge/faq',
    no: 'https://www.ducky.eco/no-no/support/ducky-challenge/ofte-stilte-sporsmal',
    ja: 'https://www.ducky.eco/ja/support/ducky-challenge/faq',
  };

  return (
    <Wrapper>
      <InfoLink
        icon={ICON.school}
        color={'#007079'}
        textColor={'#007079'}
        onClick={() => beginTutorial()}
        caption={t('challenge.ChaPaD10A.ChaSec02.revisit_tutorial')}
      />
      <Anchor
        href={faqLinks[language]}
        target={'_blank'}
        rel={'noopener noreferrer'}
      >
        <InfoLink
          icon={ICON.helpOutline}
          color={'#007079'}
          textColor={'#007079'}
          caption={t('challenge.ChaPaD10A.ChaSec02.challenge_faq')}
        />
      </Anchor>
      <FeedbackBtnContainer>
        <FeedbackBtn
          href={config.duckyFeedbackSurvey[language]}
          target={'_blank'}
        >
          {t('challenge.ChaPaD10A.ChaSec02.share_feedback')}
        </FeedbackBtn>
      </FeedbackBtnContainer>
    </Wrapper>
  );
}

export default connect(deps, ChaSec02);
